<template>
  <!--
          作者：luoyiming
          时间：2019-10-24
          描述：统计-会员统计-汇总
      -->
  <div class="">
    <div class="common-form" style="border-bottom: 1px solid #DCDFE6;">用户消费概况</div>
    <el-row :gutter="20">
      <el-col :span="6" v-for="(item, index) in dataModel.userData" :key="index">
        <div class="f-b-c">
          <div>
            <span class="tubiao icon iconfont icon-geren9" :style="{backgroundColor: item.color}"></span>
          </div>
          <div class="word-box">
            <div>
              <div class="flex-box">
                <span>{{item.name}}:</span>
                <span>{{ item.technician }}</span>
              </div>
              <el-progress :text-inside="true" :color="item.color" :show-text="false" :stroke-width="10" :percentage="item.progress"></el-progress>
            </div>
            <div style="margin-top:6px">
              <div class="flex-box">
                <span>充值金额:</span>
                <span>{{ item.recharge }}</span>
              </div>
              <el-progress :text-inside="true" :color="item.color" :show-text="false" :stroke-width="10" :percentage="item.progress"></el-progress>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import StatisticsApi from "@/api/statistics.js";
export default {
  components: {},
  data() {
    return {
      /*是否正在加载*/
      loading: true,
      progressData: [
        {
          color: "#e6a23c",
          technician: "586",
          recharge: "233",
          progress: 70
        },
        {
          color: "#67c23a",
          technician: "186",
          recharge: "156",
          progress: 70
        },
        {
          color: "#f56c6c",
          technician: "586",
          recharge: "86",
          progress: 70
        },
        {
          color: "#409eff",
          technician: "586",
          recharge: "86",
          progress: 70
        }
      ]
    };
  },
  inject: ["dataModel"],
  mounted() {
    
  },
  methods: {
    //
  }
};
</script>

<style scoped>
.flex-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.f-b-c {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 20px;
}
.word-box {
  font-weight: 700;
  flex: 1;
  /* font-size: 16px; */
  margin-left: 5px;
}
.tubiao {
  color: #fff;
  padding: 10px;
  width: 50px;
  color: #fff;
  background: #37a5f3;
  border-radius: 50%;
  height: 50px;
  text-align: center;
  line-height: 50px;
  font-size: 32px;
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/statistics/user111/part/recharge.vue